import { Helmet } from "react-helmet";

export default function GoogleTag() {
	if (!Boolean(process.env.REACT_APP_GOOGLE_TAG)) {
		return null;
	}
	return (
		<Helmet>
			<script
				async
				src={`https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GOOGLE_TAG}`}
			></script>
			<script>
				{`  window.dataLayer = window.dataLayer || [];   function gtag(){dataLayer.push(arguments);}   gtag('js', new Date());   gtag('config', '${process.env.REACT_APP_GOOGLE_TAG}'); `}
			</script>
		</Helmet>
	);
}
